const fonts = {
    '$font-family-sans-serif': '"Gill Sans", "Gill Sans MT", Calibri, sans-serif',
    '$font-family-serif': 'perpetuaregular, Perpetua, Garamond,"Times New Roman", serif',

};

export default fonts;
